var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"overlay",staticClass:"photobox-container",class:_vm.classOverlay},[_c('div',{staticClass:"overlay",on:{"click":_vm.closeOverlay}}),_vm._v(" "),_c('a',{staticClass:"close",on:{"click":_vm.closeOverlay}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }